<template>
  <Layout>
    <Card class="w-full">
      <template slot="header">
        <div class="">
          <div class="is-size-4 has-text-weight-bold">Listado de Programas</div>
          <div class="is-size-6 mt-2">
            <ul>
              <li>Local: {{ localDetail.name }}</li>
              <li>Documento: {{ document }}</li>
            </ul>
          </div>
        </div>
      </template>
      <template slot="content">
        <div>
          <div class="border p-5">
            <h3 class="mb-5 has-text-weight-bold">
              <font-awesome-icon
                :icon="['fas', 'list']"
                custom-size="default"
                class="mr-1"
              />
              Selecciona un programa de beneficios
            </h3>
            <div class="has-text-right mb-3">
              <Button variant="gray" @click.native="goBack">
                Regresar
              </Button>
            </div>
            <CompanyProviderSkeleton v-if="isLoading" />
            <div class="company-list" v-else>
              <div
                class="w-full border p-5"
                v-for="company in results"
                :key="company.id"
              >
                <div class="is-clickable" @click="chooseOption(company)">
                  <div class="columns is-align-items-center">
                    <div class="column">
                      <figure class="image is-64x64">
                        <img
                          :src="company.image_logo_crop"
                          class="card"
                          alt="company"
                        />
                      </figure>
                    </div>
                    <div class="column">
                      <span class="has-text-weight-bold">
                        {{ company.name.toUpperCase() }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </Layout>
</template>

<script>
import CompanyProviderService from "@/services/validador/CompanyProviderService";
import CompanyProviderSkeleton from "@/views/validador/home/components/CompanyProviderSkeleton.vue";
import Layout from "@/components/Layout";
import Card from "@/components/base/Card";
import CompanyService from "@/services/validador/CompanyService";
import Button from "@/components/form/Button";
export default {
  components: {
    CompanyProviderSkeleton,
    Layout,
    Card,
    Button
  },
  data() {
    return {
      results: [],
      isLoading: false,
      document: null,
      local: null,
      localDetail: {
        name: ""
      }
    };
  },
  created() {
    this.document = this.$route.query.document || null;
    this.local = this.$route.query.local || null;
    this.getCompanyProviders();
    this.getLocalDetail();
  },
  methods: {
    showMessage(type = "D", msg = "Ocurrió un error") {
      this.$store.commit("settings/SET_ALERT", {
        isAlert: true,
        type,
        msg
      });
    },
    async getCompanyProviders() {
      this.isLoading = true;
      try {
        const response = await CompanyProviderService.getCompanyProvidersByDocument(
          {
            num_document: this.document,
            local_id: this.local
          }
        );
        this.results = response.data;
      } catch (error) {
        this.showMessage();
      } finally {
        this.isLoading = false;
      }
    },
    async getLocalDetail() {
      try {
        const response = await CompanyService.getLocalDetail(this.local);
        this.localDetail = response.data;
      } catch (error) {
        this.showMessage();
      }
    },
    chooseOption(company) {
      this.$router.push({
        name: "validate-product-list",
        params: {
          company_provider_id: company.id
        },
        query: {
          document: this.document,
          local: this.local
        }
      });
    },
    goBack() {
      this.$router.push({
        name: "home-recompensa-validate"
      });
    }
  }
};
</script>
<style lang="scss">
.company-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  @media (max-width: 840px) {
    grid-template-columns: 1fr;
  }
}
</style>
